import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { Link } from 'wouter';

import { createBrandNewRow, createBrandVideosRow, createSerieRow } from '../../lib/blocks';

import { typesSections } from '../../routes';
import BanqueNationaleHeader from '../headers/BanqueNationaleHeader';
import InfiniteItemsBlocks from '../lists/InfiniteItemsBlocks';
import TypesMenu from '../menus/TypesMenu';
import HomePageBlocks from './HomePageBlocks';
import { SectionPageProps } from './SectionPage';

import styles from '../../styles/pages/section-page-banque-nationale.module.css';

interface SectionPageBanqueNationaleProps extends Omit<SectionPageProps, 'brand'> {
    brand: Brand;
    section: Section;
}

function SectionPageBanqueNationale({
    brand,
    section,
    className = null,
    type: typeSlug = null,
    ...props
}: SectionPageBanqueNationaleProps) {
    const url = useUrlGenerator();
    const type = typesSections.find(({ id, path }) => id === typeSlug || path === typeSlug) || null;
    const { query: typeQuery } = type || {};
    const { id: sectionId = null, slug: sectionSlug = null } = section || {};
    const { handle: brandHandle = null, slug: brandSlug = null } = brand || {};
    const header = <BanqueNationaleHeader className={styles.header} />;

    if (type !== null) {
        return (
            <div className={classNames([styles.container, className])} data-brand={brandHandle}>
                {header}
                <TypesMenu brand={brand} parent={section} withParent className={styles.filters} />
                <main className={styles.content}>
                    <InfiniteItemsBlocks
                        query={{
                            section: sectionId,
                            ...typeQuery,
                        }}
                        cardWithout={['category']}
                        cardWith={['brand-icon']}
                    />
                </main>
            </div>
        );
    }

    return (
        <HomePageBlocks
            {...props}
            header={header}
            additionalBlocks={[
                createBrandNewRow(brand, {
                    url: url('section', {
                        brand: brandSlug,
                        section: sectionSlug,
                        type: 'tout',
                    }),
                    cardTheme: 'box-translucent',
                    query: {
                        section: sectionId,
                    },
                }),
                createBrandVideosRow(brand, {
                    url: url('section', {
                        brand: brandSlug,
                        section: sectionSlug,
                        type: 'videos',
                    }),
                    query: {
                        section: sectionId,
                    },
                }),
                createSerieRow(
                    'histoires-de-mauvais-couts',
                    {
                        className: styles.section,
                        uniqueDocuments: false,
                        count: 10,
                        // withDescription: true,
                    },
                    {
                        order: 'new',
                    },
                ),
                createSerieRow(
                    'laddition-familiale-mettre-des-mots-et-des-chiffres-sur-la-parentalite',
                    {
                        className: styles.section,
                        uniqueDocuments: false,
                        count: 10,
                        // withDescription: true,
                    },
                    {
                        order: 'new',
                    },
                ),
            ]}
            query={{
                section: sectionId,
            }}
            withoutNew
            withoutVideos
            withoutHeaderSections
            withoutFeatured
            withoutSeries
            withoutPopular
            withoutBumper
            withoutSections
            brand={brand}
            className={classNames([styles.container, className])}
            blocksClassName={styles.blocks}
        />
    );
}

export default SectionPageBanqueNationale;
